module.exports = __webpack_public_path__ + "static/media/O3_VISUALIZED.4e96cfe6.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/utils/legend/O3_VISUALIZED.PNG
// module id = 1087
// module chunks = 0